export default "__VITE_ASSET__Cc41Pwid__"